import { apiCrm } from '../../../../http';
class LostReasonService {
  async create(data) {
    return apiCrm.post('/lost-reason', data);
  }

  async getById(id) {
    return apiCrm.get(`/lost-reason/${id}`);
  }

  async getAll() {
    return apiCrm.get('/lost-reason/all');
  }
  async update(id, data) {
    return apiCrm.put(`/lost-reason/${id}`, data);
  }

  async getByEntity(entity) {
    return apiCrm.get(`/lost-reason/entity/${entity}`);
  }
}

export default new LostReasonService();
